import { useUser } from '@/hooks/auth/useUser';
import TripFormLayout from '@/components/trips/TripFormLayout';

export function NewTripPage() {
  const { data: user } = useUser();

  return <TripFormLayout mode="create" currentUser={user} backUrl="/" />;
}
